import React from 'react';
import { Link } from 'react-router-dom';
import './OurMission.css';

const OurMission = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <h1 className="page-title">Our Mission</h1>
            <div className="page-text-content">
              <p>
                At NQC (Nova Quality Certification Agency), our mission is to empower businesses by 
                providing them with reliable, comprehensive certification services that meet international 
                standards. We are dedicated to enhancing the quality and safety of products and services 
                across various industries through our ISO, CE, Testing, Auditing, and Evaluation services.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">We strive to:</h2>
            <div className="mission-list">
              <div className="mission-item">
                <h3 className="mission-title">Ensure Compliance</h3>
                <p className="mission-description">
                  Assist businesses in complying with all relevant international regulations and standards 
                  to ensure their products and services are safe, efficient, and market-ready.
                </p>
              </div>
              <div className="mission-item">
                <h3 className="mission-title">Promote Excellence</h3>
                <p className="mission-description">
                  Foster a culture of continuous improvement and excellence within organizations, helping 
                  them to achieve and maintain the highest quality standards.
                </p>
              </div>
              <div className="mission-item">
                <h3 className="mission-title">Build Trust</h3>
                <p className="mission-description">
                  Establish trust and credibility for our clients in the global market by providing 
                  transparent, ethical, and accurate certification services.
                </p>
              </div>
              <div className="mission-item">
                <h3 className="mission-title">Support Innovation</h3>
                <p className="mission-description">
                  Encourage innovation by helping businesses to implement cutting-edge practices and 
                  technologies that enhance their competitiveness.
                </p>
              </div>
              <div className="mission-item">
                <h3 className="mission-title">Enhance Sustainability</h3>
                <p className="mission-description">
                  Support sustainable business practices that contribute to environmental protection 
                  and social responsibility.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <div className="page-text-content">
              <p>
                Through these commitments, NQC (Nova Quality Certification Agency) aims to be a trusted 
                partner for businesses seeking to improve their operational standards, gain market access, 
                and achieve long-term success.
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default OurMission;

